import { PERMISSIONS_STATUS, FULL_APP_PERMISSION } from '../consts'

export const filterCanViewFullApp = state => {
  return state.account?.permissions?.find(
    ({ desc, status }) =>
      desc === FULL_APP_PERMISSION && status === PERMISSIONS_STATUS.APPROVED
  )
}

export const canView = (permissions, userPermissions) => {
  return (
    !permissions ||
    !userPermissions?.length ||
    !!permissions?.find(permission =>
      userPermissions?.find(up => up?.desc === permission)
    )
  )
}
